import Vue from "vue";
import Selected from "../store/modules/selected";
import ListView from "../../../common/models/listViews/listView";
import DetailView from "../../../common/models/detailView/detailView";
import ObjectModelEntry from "../../../common/models/objectModelEntries/objectModelEntry";
import Organization from "../../../common/models/organization";
import PublishedListView from "../../../common/models/listViews/publishedListView";
import PublishedDetailView from "../../../common/models/detailView/publishedDetailView";
import User from "~/models/user";

export default Vue.extend({
  computed: {
    selectedUser(): User {
      return Selected.currentUser.get();
    },
    selectedListView(): ListView {
      return Selected.listView.get();
    },
    selectedPublishedListView(): PublishedListView {
      return Selected.publishedListView.get();
    },
    selectedDetailView(): DetailView {
      return Selected.detailView;
    },
    selectedPublishedDetailView(): PublishedDetailView {
      return Selected.publishedDetailView.get();
    },
    selectedObjectModelEntry(): ObjectModelEntry {
      return Selected.objectModelEntry.get()
    },
    selectedOrganization(): Organization {
      return Selected.organization.get();
    }
  },
});